/**
 * Base URL for public Application catalog endpoints.
 * Defaults to production. Override with VUE_APP_APPLICATIONS_API when pointing
 * at a local/staging API (e.g. http://localhost:8081/api/applications).
 */
export const APPLICATIONS_API =
  process.env.VUE_APP_APPLICATIONS_API ||
  'https://api.transpond.io/api/applications'

export function appLogoUrl(app) {
  if (!app) return ''
  const marketing = app.appMarketingLogoUri
  const logo = app.appLogoUri
  if (marketing && marketing !== 'http://' && marketing.startsWith('http')) return marketing
  if (logo && logo !== 'http://' && logo.startsWith('http')) return logo
  return ''
}

export function hasUsableMarketingLogo(app) {
  return !!appLogoUrl(app)
}

/** MCP / catalog-only apps that should not use OAuth appconnect. */
export function isTranspondMcpApp(app) {
  if (!app) return false
  if (app.connectUrl && String(app.connectUrl).includes('mcp.transpond.io')) return true
  return app.appName === 'Transpond MCP'
}

export function shouldHideInstallCount(app) {
  return !!(app && app.hideInstallCount)
}

/** Prefer API connectUrl; MCP defaults to the public landing page. */
export function appConnectUrl(app) {
  if (app && app.connectUrl) return app.connectUrl
  if (isTranspondMcpApp(app)) return 'https://mcp.transpond.io/'
  return null
}

export function appConnectLabel(app) {
  if (appConnectUrl(app)) return 'Get started'
  return 'Connect'
}
